<template>
    <div
        v-if="customerOrder && vendors && item"
        class="container-fluid"
        id="coi-article-data"
    >
        <div class="col-12 pt-2 px-0">
            <strong v-if="!editingArticleTitle">
                <b-badge
                    v-if="item.quantity > 1"
                    style="font-size: 24px; background: rgb(0, 0, 0); color: var(--white)"
                >
                    {{ item.quantity }}
                </b-badge>
                <span v-else style="font-size: 18px">{{ item.quantity }}</span>
                *&nbsp;
            </strong>
            <b-input-group v-if="editingArticleTitle">
                <b-input
                    ref="refEditArticleTitle"
                    v-model="newArticleTitle"
                    @keypress.enter="saveArticleTitle()"
                ></b-input>
                <b-button squared @click="editingArticleTitle = false"
                    >Abbrechen</b-button>
            </b-input-group>
            <a
                v-else
                :href="`/material/${item.stock.material.id}/edit`"
                target="_blank"
                class="pr-1"
            >
                <b v-if="item && item.articleTitle">{{ item.articleTitle }}</b>
                <b v-else>...loading</b>
            </a>
            <span v-if="customerOrder?.marketProduct?.numberOfItems > 0" class="number-box" title="NumberOfItems"
                  :class="customerOrder?.marketProduct?.numberOfItems > 1 ? 'border-danger' : 'border-success'"
            >{{customerOrder.marketProduct.numberOfItems}}</span>
            <span v-if="customerOrder?.marketProduct?.itemPackageQuantity > 0" class="number-box" title="ItemPackageQuantity"
                  :class="customerOrder?.marketProduct?.itemPackageQuantity > 1 ? 'border-danger' : 'border-success'"
            >{{customerOrder.marketProduct.itemPackageQuantity}}</span>
            <b-button
                  v-if="!editingArticleTitle && authorization.warehouse_manager"
                  @click="editArticleTitle()"
                  class="white-button py-0 px-1"
                  variant="outline-primary"
                  size="sm"
                ><span style="font-size: medium">✎</span>
            </b-button>
        </div>
        <b-row align-h="between">
            <div class="col col-8">
                <div class="d-lg-table-row">
                    <b-table-simple small stacked borderless>
                        <b-tbody>
                            <b-tr>
                                <b-td stacked-heading="SKU" class="p-0 table-stack">
                                    {{ item.sku}}
                                    <span v-if="item.stock.articleCondition == 2">&nbsp; <b-badge variant="primary">USED</b-badge></span>
                                </b-td>
                                <b-td stacked-heading="SKU (Stock)" class="p-0 table-stack">{{ item.stock.sku }}</b-td>
                                <b-td stacked-heading="Ident (EAN)" class="p-0 table-stack"><copy-to-clipboard-component alertDisplayLength='1' alertShowCopiedText="true">{{ item.stock.material.ean }}</copy-to-clipboard-component></b-td>
                                <b-td stacked-heading="Lieferant" class="p-0 table-stack" >{{ vendorName }} / auf {{ customerOrder.marketaccount.name }}</b-td >
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </div>
            </div>

            <div class="col-4">
                <table class="retarded-table float-right">
                    <tbody>
                        <tr>
                            <td class="retarded-table-l2oz">VK</td>
                            <td class="retarded-table-0lax">{{priceGross}}</td>
                            <td class="retarded-table-0lax" v-if="priceGrossOriginalCurrency" style="text-align: right;"><b    class="mx-1">{{priceGrossOriginalCurrency}}</b></td>
                        </tr>
                        <tr>
                            <td class="retarded-table-l2oz">Artikel</td>
                            <td class="retarded-table-0lax">{{priceNet}}</td>
                            <td class="retarded-table-0lax" v-if="priceNetOriginalCurrency" style="text-align: right;"><b    class="mx-1">{{priceNetOriginalCurrency}}</b></td>
                        </tr>
                        <tr>
                            <td class="retarded-table-l2oz">Shipping</td>
                            <td class="retarded-table-0lax">{{priceShipping}}</td>
                            <td class="retarded-table-0lax" v-if="priceShippingOriginalCurrency" style="text-align: right;"><b class="mx-1">{{priceShippingOriginalCurrency}}</b></td>
                        </tr>
                        <tr id="mp-abgef" >
                            <td class="retarded-table-l2oz">von MP abgeführt</td>
                            <td class="retarded-table-0lax">{{tax}}</td>
                            <td class="retarded-table-0lax" v-if="taxOriginalCurrency" style="text-align: right;"><b class="mx-1">{{taxOriginalCurrency}}</b></td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </b-row>
    </div>
</template>
<style>
.table-stack {
    white-space: nowrap;
}
.span-gray {
    color: gray;
}
.badge-orange {
    background-color: #fcb103;
    color: black;
}
.white-button {
    background:white!important;
}
.white-button:hover {
    background:#007bff!important;
}
.retarded-table {
        border: none;
        border-collapse: collapse;
        border-spacing: 0;
}
.retarded-table td {
        border-style: solid;
        border-width: 0;
        font-family: Arial, sans-serif;
        font-size: 14px;
        overflow: hidden;
        padding: 1px 5px;
        word-break: normal;
}
.retarded-table .retarded-table-l2oz {
        font-weight: bold;
        text-align: right;
        vertical-align: top
}
.retarded-table .retarded-table-0lax {
        text-align: left;
        vertical-align: top
}
</style>
<script>
export default {
    props: ["customerOrder", "vendors", "authorization"],
    data() {
        return {
            item: null,
            editingArticleTitle: false,
            newArticleTitle: null,
            tableItems: [
                {
                    "SKU (item)": 123,
                    "SKU (Stock)": 123,
                    EAN: 123,
                    Lieferant: "asldkj",
                },
            ],
            tableFields: [
                {
                    key: "SKU (item)",
                    label: "SKU (item)",
                    sortable: true,
                    thClass: "my-0 py-0",
                    trClass: "my-0 py-0",
                },
                {
                    key: "SKU (Stock)",
                    label: "SKU (Stock)",
                    sortable: true,
                    thClass: "my-0 py-0",
                    trClass: "my-0 py-0",
                },
                {
                    key: "EAN",
                    label: "EAN",
                    sortable: true,
                    thClass: "my-0 py-0",
                    trClass: "my-0 py-0",
                },
            ],
        };
    },
    methods: {
        focusField(name) {
            setTimeout(() => this.$refs[name].focus(), 165);
        },
        saveArticleTitle() {
            axios.post("/material/save_article_title", {
                customerOrderItemId: this.item.id,
                articleTitle: this.newArticleTitle,
            }).then(({ data }) => {
                this.newArticleTitle = data.articleTitle;
                // we don't want to update the whole object, since we don't pass back other stuff
                // like customerorderitemdeliveries and etc. Instead we only want to mutate the
                // title itself. This will affect all coi instances in the whole Vue.
                this.item.articleTitle = data.articleTitle;
                this.editingArticleTitle = false;
                this.$bvToast.toast("Name erfolgreich gespeichert.", {
                    title: "Material Name ändern",
                    autoHideDelay: 1000,
                    appendToast: false,
                    variant: "success",
                });
            }).catch((error) => {
                this.$bvToast.toast( "Etwas ist schief gegangen. Materialname nicht gespeichert.", {
                    title: "Material Name ändern",
                    autoHideDelay: 3000,
                    appendToast: false,
                    variant: "danger",
                });
                console.error(error);
            });
        },
        editArticleTitle() {
            this.editingArticleTitle = true;
            this.newArticleTitle = this.item.articleTitle;
            this.focusField("refEditArticleTitle");
        },
        formatOriginalCurrency(value) {
                if (!value) return null;
                // NOTICE: if it is a Verlustsendung use the currencyName from customerorderitem, 
                // unlike most customerOrderItems, currencyName here is correctly set.
                // this is necessary because Verlustendungen all are in one virtual Marketplace
                // meaning all orders look like they come from an EUR country.
                // During Verlustsendung erstellung the market's currencyIso is copied in coi.currencyName.
                let currencyIso = "";
                if(10000 == this.customerOrder.marketAccount.id) {
                    currencyIso = this.customerOrder.customerorderitems[0].currencyName;
                }else{
                    currencyIso = this.customerOrder.marketAccount.country.currencyIso;
                }
                let currencySymbol = "";
                switch (currencyIso) {
                    case "EUR": 
                            return null;
                    case "USD":
                        currencySymbol = "$";
                        break;
                    case "JPY":
                        currencySymbol = "¥";
                        break;
                    case "GBP":
                        currencySymbol = "£";
                        break;
                    default: 
                        currencySymbol = " " + currencyIso;
                }

                return `(${Number.parseFloat(value).toFixed(2)}${currencySymbol})`;            
        },
        formatEuroCurrency(value) {
            return `${Number.parseFloat(
                this.customerOrder.currencyToEuro * value
            ).toFixed(2)}€`;
        },
    },
    computed: {
        vendorName: function () {
            if (!this.vendors) return "???";
            return this.vendors.find((v) => v.id === this.item.stock.vendorId).name;
        },
        priceGross: function () {
            return this.formatEuroCurrency(this.item.articlePriceGross);
        },
        priceNet: function () {
            return this.formatEuroCurrency(this.item.articlePriceClear);
        },
        priceShipping: function () {
            return this.formatEuroCurrency(this.customerOrder.priceShippingFee);
        },
        tax: function () {
            return this.formatEuroCurrency(this.customerOrder.priceCompleteTax);
        },
        priceGrossOriginalCurrency: function () {
            return this.formatOriginalCurrency(this.item.articlePriceGross);
        },
        priceNetOriginalCurrency: function () {
            return this.formatOriginalCurrency(this.item.articlePriceClear);
        },
        priceShippingOriginalCurrency: function () {
            return this.formatOriginalCurrency(this.customerOrder.priceShippingFee);
        }, // when is this ever NOT in euro???
        taxOriginalCurrency: function () {
            return this.formatOriginalCurrency(this.customerOrder.priceCompleteTax);
        },
    },
    created() {
        this.item = this.customerOrder.customerorderitems[0];
    },
};
</script>
